module.exports = __webpack_public_path__ + "static/media/MIAB9684-180730-1_Small.86c5134a.jpg";